import type { ReactNode } from 'react';

/**
 * Barra do painel (spec 34 R7, spec 36 R6): o nome à esquerda e o primário à direita; abaixo de
 * 640 px o primário desce para baixo do título. Sem primário, só o título.
 */
export function BarraDaEtapa({ titulo, children }: { titulo: string; children?: ReactNode }) {
  return (
    <div
      className="flex flex-col items-start gap-2 sm:flex-row sm:items-center sm:justify-between"
      data-barra-etapa
    >
      <h2 className="text-lg font-semibold text-foreground">{titulo}</h2>
      {children}
    </div>
  );
}
